import React, { FC, useEffect, useRef, useState } from "react";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Card,
  Layout,
  Dropdown,
  DatePicker,
} from "antd";
import {
  ArrowLeftOutlined,
  AudioMutedOutlined,
  AudioOutlined,
  CloseOutlined,
  DownOutlined,
  CheckOutlined,
  PhoneOutlined,
  UserAddOutlined,
  EyeOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  DownloadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { ReactSVG } from "react-svg";
import { wrapRequestPayload } from "../../../helpers/request/RequestPayload";
import {
  getProjectsSubscriptionTopic,
  getProjectsRequestPublishTopic,
  getWorkerTokenRequestPublishTopic,
  getWorkerTokenSubscriptionTopic,
  getAggregateBdsPublishTopic,
  getAggregateBdsSubscriptionTopic,
  getTwilioUserStatusPublishTopic,
  getTwilioUserStatusSubscriptionTopic,
  getTwilioUserSubscriptionTopic,
  getTwilioReservationCreatedSubscriptionTopic,
  getTwilioReservationTimeoutSubscriptionTopic,
  getTwilioReservationCancelledSubscriptionTopic,
  getTwilioTaskCreatedSubscriptionTopic,
  getTwilioRecordingSavedSubscriptionTopic,
  getTwilioAcceptReservationSubscriptionTopic,
  getTwilioRejectReservationSubscriptionTopic,
  getTwilioCompleteReservationSubscriptionTopic,
  getTwilioAddParticipantSubscriptionTopic,
  getTwilioRecordOutgoingSubscriptionTopic,
  getTwilioHoldCallSubscriptionTopic,
  getTwilioCompleteCallSubscriptionTopic,
  getEventUserStatusUpdatedSubscriptionTopic,
  getTwilioTaskCancelledSubscriptionTopic,
  getTwilioTaskCompletedSubscriptionTopic,
  updateTwilioUserStatusPublishTopic,
  updateTwilioUserStatusSubscriptionTopic,
  getTwilioCompleteReservationWorkerSubscriptionTopic,
  callAcceptedPublishTopic,
} from "hooks/MQTTConstants";
import { useLocation } from "react-router-dom";
import { SocketTopics, UserTopics } from "constants/enums";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import { Device } from "@twilio/voice-sdk";
import "./CallCenter.scss";
import SaveRecordingModal from "./SaveRecordingModal";
import useSocketActions from "../../../hooks/socketActions";
import {
  GET_CALL_LOGS,
  DECRYPT_TOKEN,
  ACCEPT_RESERVATION,
  REJECT_RESERVATION,
  COMPLETE_TASK,
  GET_USER_STATUS,
  UPDATE_USER_STATUS,
  SAVE_RECORDING,
  HOLD_CALL,
  ADD_PARTICIPANT,
  RECORD_OUTGOING,
} from "../../../reducers/reducer";
import WelcomeModal from "./WelcomeModal";
import OutgoingModal from "./OutgoingModal";
import PersonItem from "../../../common/PersonItem";
import Timer from "../../../common/Timer";
import { formatForRedis } from "utils/appUtil";
import { pushNotification } from "utils/notifications";
const xlsx = require("json-as-xlsx");

const xlsData = [
  {
    sheet: "Call logs",
    columns: [
      { label: "Timestamp", value: "timestamp" },
      { label: "From", value: "from" },
      { label: "Call taker", value: "calltaker" },
      { label: "Duration", value: "duration" },
      { label: "Type", value: "type" },
    ],
    content: [],
  },
];

const settings = {
  fileName: "callLogs", // Name of the resulting spreadsheet
  extraLength: 3, // A bigger number means that columns will be wider
  writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
};

let reservationTimeout, outgoingTimeout;

const { RangePicker } = DatePicker;

const CallCenterModal: FC<{ socket: ISocket; params?: any }> = ({
  socket,
  params,
}) => {
  const { search } = useLocation();
  const { projects, userRequests, requestIds, encrypted_token } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();
  const device = useRef(null);
  const connection = useRef(null);
  const [callFilter, setCallFilter] = useState<string>("in-queue");
  const callFilterRef = useRef<string>("in-queue");
  const [currentUserObj, setCurrentUserObj] = useState<any>({});
  const [currentUserStatus, setCurrentUserStatus] = useState();
  const [reservation, setReservation] = useState<any>();
  const [callOngoing, setCallOngoing] = useState<boolean>(false);
  const [addParticipant, setAddParticipant] = useState<boolean>(false);
  const [mute, setMute] = useState<boolean>(false);
  const [hold, setHold] = useState<boolean>(false);
  const [audio, setAudio] = useState<any>();
  const [pingAudio, setPingAudio] = useState<any>();
  const [callLogs, setCallLogs] = useState<any>([]);
  const callLogsRef = useRef<any>([]);
  const [isSaveRecordingVisible, setIsSaveRecordingVisible] =
    useState<boolean>(false);
  const [isWelcomeModalVisible, setIsWelcomeModalVisible] =
    useState<boolean>(true);
  const [outgoingModalVisible, setOutgoingModalVisible] =
    useState<boolean>(false);
  const { getUserRequestPayload } = useSocketActions();
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [missed, setMissed] = useState<boolean>(false);
  const userRequestRef = useRef<any>([]);
  const [callTakers, setCallTakers] = useState<any>([]);
  const handleChange = (num: string | number | null) => {
    if (num) setPhoneNumber(`${phoneNumber}${num}`);
    else setPhoneNumber(phoneNumber.slice(0, -1));
  };
  const ongoing = useRef(false);
  const outgoing = useRef(false);
  const [callConnecting, setCallConnecting] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const dateRange = useRef<any>();

  const initializeDevice = (client_token) => {
    device.current = new Device(client_token, { allowIncomingWhileBusy: true });
    device.current.register();
    device.current.on("incoming", (con) => {
      con.on("accept", (conn) => {
        console.log("connection on accept");
        connection.current = conn;
      });
      console.log("incoming here", con);
      con.accept();
      setCallOngoing(true);
      ongoing.current = true;
      setCallConnecting(false);
    });
    device.current.on("destroyed", (resp) => {
      console.log("destroyed", resp);
    });
    device.current.on("error", (resp) => {
      console.log("error", resp);
    });
  };

  const getCallTakerUsers = () => {
    const connectionId = encrypted_token?.connectionId;
    const userRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@serviceId:{'${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "TIMEOUT 5000",
        },
        load: {
          id: "$.objectId",
          status: "$.nonpersistent.static.live.status",
          live: "$.persistent.static.live",
          admin: "$.persistent.static.admin",
          workerSid: `$..admin.profile.workerSid`,
        },
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {},
      filter: {
        expression: `exists(@workerSid) && @workerSid !== ''`,
      },
      anyStatus: false,
    };
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getAggregateBdsPublishTopic(connectionId),
      wrapRequestPayload(userRequest, requestIds.user)
    );
  };

  const getCurrentUserStatus = () => {
    const connectionId = encrypted_token?.connectionId;
    const userId = encrypted_token?.userId;
    const requestData: any = {
      userId,
      serviceId: projects?.userServiceId,
    };
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioUserStatusPublishTopic(connectionId),
    //   wrapRequestPayload(userRequest)
    // );

    dispatch(
      GET_USER_STATUS({
        requestData,
        callback: (response) => {
          // console.log("get user status response", response);
          setCurrentUserStatus(response?.status ?? "grey");
        },
      })
    );
  };

  useEffect(() => {
    if (projects?.adminUserId) {
      const connectionId = encrypted_token?.connectionId;
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAggregateBdsSubscriptionTopic(connectionId)
      );
      getCallTakerUsers();
      getCurrentUserStatus();
      getCallLogs("task.created");
    }
  }, [projects]);

  useEffect(() => {
    if (encrypted_token) {
      if (encrypted_token?.userId && encrypted_token?.connectionId) {
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          getProjectsSubscriptionTopic(encrypted_token?.connectionId)
        );
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getProjectsRequestPublishTopic(encrypted_token?.connectionId),
          wrapRequestPayload({
            userId: encrypted_token?.userId,
          })
        );
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          getWorkerTokenSubscriptionTopic(encrypted_token?.connectionId),
          (payload) => {
            console.log("token payload here", payload);
            if (payload?.response?.data?.client_token) {
              initializeDevice(payload?.response?.data?.client_token);
            }
          }
        );
        socket.subscribeToSurvey(
          SocketTopics.SurveyTopics,
          getTwilioUserSubscriptionTopic(encrypted_token?.connectionId),
          (response) => {
            if (response?.data?.[0]?.[0]?.lastTask?.status === "pending") {
              setIsSaveRecordingVisible(true);
            }
          }
        );
        const sound = new Audio("/audio/ring-normal.wav");
        sound.loop = true;
        setAudio(sound);
        const pingSound = new Audio("/audio/beep-06.mp3");
        setPingAudio(pingSound);
      }
    }
  }, [encrypted_token]);

  useEffect(() => {
    if (socket.client) {
      const query = new URLSearchParams(search);
      // const token = query.get("token");
      const connectionId = query.get("connectionId");
      const userId = query.get("userId");
      // if (token) {
      //   dispatch(
      //     DECRYPT_TOKEN({
      //       data: { payload: token },
      //       callback: (data) => {},
      //     })
      //   );
      // }
      dispatch({
        type: "ADD_ENCRYPTED_TOKEN",
        payload: {
          connectionId,
          userId,
        },
      });
      document.title = "Call center - Beam";
    }
  }, [search, socket.client]);

  const subscribeWorker = (workerSid) => {
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioReservationCreatedSubscriptionTopic(workerSid),
      (response) => {
        if (outgoing.current) {
          return;
        }

        // console.log("reservation here", response?.data);

        setReservation(response?.data);
        setCallOngoing(false);
        ongoing.current = false;
        setCallConnecting(false);
        if (reservationTimeout) clearTimeout(reservationTimeout);
        reservationTimeout = setTimeout(() => {
          if (!ongoing.current) {
            setReservation(undefined);
            setCallOngoing(false);
            ongoing.current = false;
            audio?.pause();
          }
        }, 18000);
        audio?.play();
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioReservationTimeoutSubscriptionTopic(workerSid),
      (response) => {
        if (outgoing.current) {
          return;
        }
        setReservation(undefined);
        setCallOngoing(false);
        ongoing.current = false;
        audio?.pause();
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioReservationCancelledSubscriptionTopic(workerSid),
      (response) => {
        if (outgoing.current) {
          return;
        }
        setReservation(undefined);
        setCallOngoing(false);
        ongoing.current = false;
        audio?.pause();
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioTaskCreatedSubscriptionTopic(workerSid),
      (response) => {
        if (callFilterRef.current === "in-queue") {
          const logs = [...callLogsRef.current];
          logs.unshift({
            output: {
              activeCallSId: response?.data?.callSid,
              activeCallTimestamp: parseInt(response?.data?.timestamp),
              activeCallerPhoneNumber: response?.data?.from,
              callStatus: "task.created",
            },
            status: "task.created",
          });
          setCallLogs(logs);
          callLogsRef.current = logs;
        }
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioRecordingSavedSubscriptionTopic(workerSid),
      (response) => {
        switch (callFilterRef.current) {
          case "completed":
            getCallLogs("task.complete", true);
            break;
          case "missed":
            getCallLogs("task.no-answer", true);
            break;
        }
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getEventUserStatusUpdatedSubscriptionTopic(workerSid),
      (response) => {
        const userId = encrypted_token?.userId;
        if (userId === response?.data?.userId) {
          setCurrentUserStatus(response?.data?.status);
        }
        let users = [...(userRequestRef.current || [])];
        const userIdx = users.findIndex((user) => {
          return user.id === response?.data?.userId;
        });
        if (userIdx !== -1) {
          users[userIdx].nonpersistent.static.live.status = {
            name: response?.data?.status,
            color: response?.data?.status,
          };
        }
        setCallTakers(users);
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioTaskCancelledSubscriptionTopic(workerSid),
      (response) => {
        if (callFilterRef.current === "missed") {
          const logs = [...callLogsRef.current];
          logs.unshift({
            output: {
              objectId: response?.data?.objectId,
              activeCallSId: response?.data?.callSid,
              activeCallTimestamp: parseInt(response?.data?.timestamp),
              activeCallerPhoneNumber: response?.data?.from,
              callStatus: "task.no-answer",
            },
            status: "task.no-answer",
          });
          setCallLogs(logs);
          callLogsRef.current = logs;
        } else if (callFilterRef.current === "in-queue") {
          const logs = [...callLogsRef.current];
          const index = logs.findIndex((x) => {
            return x.output.activeCallSId === response?.data?.callSid;
          });
          if (index !== -1) {
            logs.splice(index, 1);
            setCallLogs(logs);
            callLogsRef.current = logs;
          }
        }
        setMissed(true);
        pingAudio.play();
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioTaskCompletedSubscriptionTopic(workerSid),
      (response) => {
        if (callFilterRef.current === "completed") {
          const logs = [...callLogsRef.current];
          logs.unshift({
            output: {
              activeCallSId: response?.data?.reservation?.callSid,
              activeCallTimestamp: new Date().getTime(),
              activeCallerPhoneNumber: response?.data?.reservation?.phoneNumber,
              activeDispatcherId: response?.data?.workerSid,
              callStatus: "task.completed",
            },
            status: "task.completed",
          });
          setCallLogs(logs);
          callLogsRef.current = logs;
        } else if (callFilterRef.current === "in-queue") {
          const logs = [...callLogsRef.current];
          const index = logs.findIndex((x) => {
            return (
              x.output.activeCallSId === response?.data?.reservation?.callSid
            );
          });
          if (index !== -1) {
            logs.splice(index, 1);
            setCallLogs(logs);
            callLogsRef.current = logs;
          }
        }
      }
    );
  };

  const getCallLogs = (status, silent = false) => {
    if (!silent) {
      setCallLogs([]);
    }
    callLogsRef.current = [];
    const requestData = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:workflow:startedAt`,
          searchQuery: `@configId:{${
            process.env.REACT_APP_CALL_CENTER_WORKFLOW_ID
          }}@partitions:{'org\\:${formatForRedis(projects?.userServiceId)}'}`,
        },
        load: {
          objectId: "$.objectId",
          output: "$.dataset.output",
          startedAt: "$.flow.startedAt",
          status: "$.dataset.output.callStatus",
        },
      },
      sortBy: {
        properties: [
          {
            field: "@startedAt",
            order: "DESC",
          },
        ],
        max: 100000,
      },
      filter: {
        expression: `exists(@status) && @status == '${status}'`,
      },
      result: {
        pagination: {
          offset: 0,
          limit: 50,
        },
      },
    };
    dispatch(
      GET_CALL_LOGS({
        requestData,
        callback: (response) => {
          setCallLogs(response);
          callLogsRef.current = response || [];
          if (callFilterRef.current === "missed") {
            setMissed(false);
          }
        },
      })
    );
  };

  const downloadCallLogs = (status = "task.complete") => {
    if (!dateRange.current) return;

    let startDate = dateRange.current?.[0]?.toDate();
    let endDate = dateRange.current?.[1]?.toDate();

    startDate.setHours(0, 0, 0);
    endDate.setHours(24, 0, 0);

    xlsData[0].content = [];

    setDownloading(true);

    const requestData = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:workflow:startedAt`,
          searchQuery: `@configId:{${process.env.REACT_APP_CALL_CENTER_WORKFLOW_ID}}`,
        },
        load: {
          objectId: "$.objectId",
          output: "$.dataset.output",
          startedAt: "$.flow.startedAt",
          status: "$.dataset.output.callStatus",
        },
      },
      sortBy: {
        properties: [
          {
            field: "@startedAt",
            order: "DESC",
          },
        ],
        max: 100000,
      },
      filter: {
        expression: `exists(@status) && @status == '${status}' && exists(@startedAt) && @startedAt > ${startDate.getTime()} &&  @startedAt < ${endDate.getTime()}`,
      },
    };
    dispatch(
      GET_CALL_LOGS({
        requestData,
        callback: (response) => {
          // console.log("download call logs", response);

          setDownloading(false);

          for (const log of response) {
            if (
              log.output.activeDispatcherId &&
              log.output.activeDispatcherId !== ""
            ) {
              xlsData[0].content.push({
                timestamp: new Date(
                  log.output.activeCallTimestamp
                ).toLocaleString(),
                from: log.output.activeCallerPhoneNumber,
                type: log.output.callType,
                calltaker: getUserName(log.output.activeDispatcherId) ?? "",
                duration: log.output.callDuration,
              });
            }
          }
          xlsx(xlsData, settings); // Will download the excel file
        },
      })
    );
  };

  useEffect(() => {
    if (userRequests && socket.client) {
      const userId = encrypted_token?.userId;
      const connectionId = encrypted_token?.connectionId;
      if (userRequests?.[`${requestIds.user}`]) {
        const currentUser = userRequests?.[`${requestIds.user}`].find((x) => {
          return x.id === userId;
        });
        if (
          currentUser &&
          JSON.stringify(userRequestRef.current) !==
            JSON.stringify(userRequests?.[`${requestIds.user}`])
        ) {
          setCurrentUserObj(currentUser);
          if (currentUser?.admin?.lastTask?.status === "pending") {
            setIsSaveRecordingVisible(true);
          }
          socket.publishToEvent(
            SocketTopics.PublishPageTopics,
            getWorkerTokenRequestPublishTopic(connectionId),
            wrapRequestPayload({
              userId: currentUser?.admin?.profile?.workerSid,
              serviceId: projects?.userServiceId,
            })
          );
          if (currentUser?.admin?.profile?.workerSid) {
            subscribeWorker(currentUser?.admin?.profile?.workerSid);
          }
        }
        // console.log("call takers", userRequests?.[`${requestIds.user}`] || []);
        setCallTakers(userRequests?.[`${requestIds.user}`] || []);
        userRequestRef.current = userRequests?.[`${requestIds.user}`];
      }
    }
  }, [userRequests, socket.client]);

  const getUserName = (workerSid) => {
    const currentUser = userRequests?.[`${requestIds.user}`].find((x) => {
      return x?.admin?.profile?.workerSid === workerSid;
    });
    return currentUser?.fullName || workerSid;
  };

  const validateCurrentUserTask = (userId) => {
    console.log('validate current user task');
    const connectionId = encrypted_token?.connectionId;
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.SearchInUser,
      getUserRequestPayload(userId, "$", "$..admin"),
      getTwilioUserSubscriptionTopic(connectionId),
      projects?.userServiceId
    );
  };

  const updateUserStatus = (status) => {
    const connectionId = encrypted_token?.connectionId;
    const userId = encrypted_token?.userId;
    const requestData: any = {
      userId,
      serviceId: projects?.userServiceId,
      status,
    };
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   updateTwilioUserStatusPublishTopic(connectionId),
    //   wrapRequestPayload(userRequest)
    // );

    dispatch(
      UPDATE_USER_STATUS({
        requestData,
        callback: (response) => {
          // console.log("update user status response", response);
          setCurrentUserStatus(response?.status ?? "grey");
        },
      })
    );
  };

  const acceptCall = () => {
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioAcceptReservationSubscriptionTopic(reservation?.callSid),
    //   wrapRequestPayload({})
    // );
    const requestData = {
      ...reservation,
      dispatcherId: currentUserObj?.admin?.profile?.workerSid,
    };
    dispatch(
      ACCEPT_RESERVATION({
        requestData,
        callback: (response) => {
          // console.log("reservation accepted response", response);
        },
      })
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      callAcceptedPublishTopic(currentUserObj?.id),
      wrapRequestPayload({
        reservation,
        workerSid: currentUserObj?.admin?.profile?.workerSid,
      })
    );
    //     {
    //     "workflowId": "109060",
    //     "twilioReservation": {
    //         "taskSid": "WTb22fc77d946ce3f11a82f0487587c381",
    //         "reservationSid": "WR39d64e69b152614cefca37e15a988592",
    //         "callerSid": "CA42a0a6bbf980ae43cae5d23e93cbd7b3"
    //     },
    //     "callSid": "CA42a0a6bbf980ae43cae5d23e93cbd7b3",
    //     "phoneNumber": "client:Anonymous"
    // }

    // test
    // setCallOngoing(true);
    // ongoing.current = true;
    setCallConnecting(true);
    setTimeout(() => {
      if (!ongoing.current) {
        setCallConnecting(false);
        // pushNotification("Connecting call failed! Try again", "error", "TOP_CENTER", 1000);
      }
    }, 5000);
    audio?.pause();
    if (reservationTimeout) clearTimeout(reservationTimeout);
  };

  const rejectCall = () => {
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioRejectReservationSubscriptionTopic(reservation?.callSid),
    //   wrapRequestPayload({})
    // );

    const requestData = {
      ...reservation,
      dispatcherId: currentUserObj?.admin?.profile?.workerSid,
    };

    dispatch(
      REJECT_RESERVATION({
        requestData,
        callback: (response) => {
          // console.log("reservation rejected response", response);
        },
      })
    );

    setReservation(false);
    audio?.pause();
    if (reservationTimeout) clearTimeout(reservationTimeout);
  };

  const handleAddParticipant = () => {
    // const connectionId = encrypted_token?.connectionId;
    let phone = phoneNumber;
    if (phone.indexOf("+") === -1) phone = "+1" + phone;
    const requestData = {
      taskSid: reservation?.twilioReservation?.taskSid,
      to: phone,
      outgoing: outgoing.current,
      callSid: reservation?.callSid,
      userServiceId: projects?.userServiceId,
    };
    dispatch(
      ADD_PARTICIPANT({
        requestData,
        callback: (response) => {
          // console.log("add particioant response", response);
        },
      })
    );
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioAddParticipantSubscriptionTopic(connectionId),
    //   wrapRequestPayload({
    // taskSid: reservation?.twilioReservation?.taskSid,
    // to: phone,
    // outgoing: outgoing.current,
    // callSid: reservation?.callSid,
    //   })
    // );
    setAddParticipant(false);
    setPhoneNumber("");
  };

  const holdCall = (hold) => {
    // const connectionId = encrypted_token?.connectionId;
    const requestData = {
      taskSid: reservation?.twilioReservation?.taskSid,
      hold,
      outgoing: outgoing.current,
      callSid: reservation?.callSid,
      userServiceId: projects?.userServiceId,
    };
    dispatch(
      HOLD_CALL({
        requestData,
        callback: (response) => {
          // console.log("hold call response", response);
        },
      })
    );
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioHoldCallSubscriptionTopic(connectionId),
    //   wrapRequestPayload({
    //     taskSid: reservation?.twilioReservation?.taskSid,
    //     hold,
    //     outgoing: outgoing.current,
    //     callSid: reservation?.callSid,
    //   })
    // );
    setHold(hold);
  };

  const hangUpCall = () => {
    if (connection.current) {
      connection.current.disconnect();
    }
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getTwilioCompleteReservationSubscriptionTopic(reservation?.callSid),
    //   wrapRequestPayload({
    //     reservation,
    //     workerSid: currentUserObj?.admin?.profile?.workerSid,
    //   })
    // );
    const requestData = {
      ...reservation,
      dispatcherId: currentUserObj?.admin?.profile?.workerSid,
    };
    dispatch(
      COMPLETE_TASK({
        requestData,
        callback: (response) => {
          // console.log("reservation completed response", response);
        },
      })
    );
    callTakers?.map((item, i) => {
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getTwilioCompleteReservationWorkerSubscriptionTopic(
          reservation?.callSid,
          item?.admin?.profile?.workerSid
        ),
        wrapRequestPayload({
          reservation,
          workerSid: currentUserObj?.admin?.profile?.workerSid,
        })
      );
    });
    setCallOngoing(false);
    setReservation(false);
    setHold(false);
    ongoing.current = false;
    outgoing.current = false;
    if (outgoingTimeout) clearTimeout(outgoingTimeout);
    validateCurrentUserTask(currentUserObj?.id);
  };

  const recordOutgoing = (phoneNumber, workflowId) => {
    const callSid = connection.current?.parameters?.CallSid?.toString();
    if (callSid && callSid.startsWith("CA")) {
      setReservation({ phoneNumber, callSid, outgoing: true });
      // const connectionId = encrypted_token?.connectionId;
      // socket.publishToEvent(
      //   SocketTopics.PublishPageTopics,
      //   getTwilioRecordOutgoingSubscriptionTopic(connectionId),
      //   wrapRequestPayload({
      // callSid,
      // workerSid: currentUserObj?.admin?.profile?.workerSid,
      // phoneNumber,
      // workflowId,
      //   })
      // );
      const requestData = {
        callSid,
        workerSid: currentUserObj?.admin?.profile?.workerSid,
        phoneNumber,
        workflowId,
        userServiceId: projects?.userServiceId,
      };
      dispatch(
        RECORD_OUTGOING({
          requestData,
          callback: (response) => {
            // console.log("record outgoing response", response);
          },
        })
      );
    } else {
      if (outgoingTimeout) clearTimeout(outgoingTimeout);
      outgoingTimeout = setTimeout(() => {
        recordOutgoing(phoneNumber, workflowId);
      }, 1000);
    }
  };

  const callOutgoing = async (item) => {
    let phoneNumber = item.output.activeCallerPhoneNumber;
    // let phoneNumber = "+923214556567";
    if (ongoing.current) return;
    connection.current = await device.current.connect({
      params: {
        To: phoneNumber,
        ServiceId: projects?.userServiceId,
      },
    });
    audio?.pause();
    setReservation({ phoneNumber, outgoing: true });
    setCallOngoing(true);
    outgoing.current = true;
    if (reservationTimeout) clearTimeout(reservationTimeout);
    if(item?.objectId){
      recordOutgoing(phoneNumber, item?.objectId?.toString());
    }
  };

  const completeCall = (workflowId) => {
    const connectionId = encrypted_token?.connectionId;
    const logs = [...callLogsRef.current];
    const index = logs.findIndex((x) => {
      return x.objectId.toString() === workflowId;
    });
    if (index !== -1) {
      logs.splice(index, 1);
      setCallLogs(logs);
      callLogsRef.current = logs;
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getTwilioCompleteCallSubscriptionTopic(connectionId),
      wrapRequestPayload({
        workerSid: currentUserObj?.admin?.profile?.workerSid,
        workflowId,
        serviceId: projects?.userServiceId,
      })
    );
  };

  const menu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          updateUserStatus("green");
        }}
      >
        <div className="status-badge green" />
        <span className="ml-4">Online</span>
      </li>

      <li
        onClick={() => {
          updateUserStatus("amber");
        }}
      >
        <div className="status-badge orange" />
        <span className="ml-4">Away</span>
      </li>

      <li
        onClick={() => {
          updateUserStatus("red");
        }}
      >
        <div className="status-badge red" />
        <span className="ml-4">Busy</span>
      </li>

      <li
        onClick={() => {
          updateUserStatus("grey");
        }}
      >
        <div className="status-badge grey" />
        <span className="ml-4">Offline</span>
      </li>
    </ul>
  );

  return (
    <Modal
      title=""
      visible={true}
      width="100%"
      className="beam-modal analytics-summary-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Layout className="main-layout exec-layout">
        <div className="header-panel mr-4" style={{ justifyContent: "start" }}>
          <ReactSVG src="/images/logo-icon.svg" className="logo-icon" />
          <div className="d-flex">
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={["click"]}
            >
              <div className="user-avatar d-flex">
                <img width="40" src={"/images/users/user.png"} alt="" />
                <p className="mx-2">{currentUserObj?.fullName ?? ""}</p>
                <div
                  className={`status-badge ${currentUserStatus} position-absolute`}
                />
                <DownOutlined style={{ fontSize: 14 }} />
              </div>
            </Dropdown>
          </div>
        </div>
        <Row gutter={30}>
          <Col className="gutter-row card-max-height" sm={24} md={8}>
            <Card className="filter-card">
              <Row className="mt-3">
                {callTakers?.map((item, i) => (
                  <Col span={24}>
                    <PersonItem
                      onClick={() => {}}
                      avatar="/images/users/user.png"
                      userObj={item}
                    />
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>

          <Col
            className="gutter-row card-max-height"
            sm={24}
            md={reservation ? 8 : 16}
          >
            <Card className="filter-card main-card">
              <Row className="mt-3 w-100 d-fles" style={{justifyContent: 'space-between'}}>
                <Button
                  className="beam-btn round-btn cover call-btn"
                  style={{ minWidth: 40, minHeight: 40 }}
                  onClick={() => {
                    // handleAddParticipant();
                    setOutgoingModalVisible(true);
                  }}
                >
                  <ReactSVG src="/images/call-icon.svg" />
                </Button>

                <div>
                  <RangePicker
                    className="mr-3"
                    onChange={(e) => {
                      // console.log("date change", e);
                      dateRange.current = e;
                    }}
                  />
                  <Button
                    className={`beam-btn`}
                    style={{ minWidth: 40 }}
                    loading={downloading}
                    onClick={() => {
                      downloadCallLogs();
                    }}
                  >
                    <DownloadOutlined />
                  </Button>
                </div>
              </Row>

              <Row className="mt-3 w-100">
                <Row gutter={16} className="d-flex px-1 flex-wrap w-100">
                  <Col sm={4}>
                    <h5 className="mb-0">Filters</h5>
                  </Col>
                  <Col
                    sm={5}
                    onClick={() => {
                      setCallFilter("in-queue");
                      callFilterRef.current = "in-queue";
                      getCallLogs("task.created");
                    }}
                  >
                    <Button
                      className={`beam-btn w-70 ${
                        callFilter === "in-queue" ? "green-btn cover" : ""
                      }`}
                    >
                      In Queue
                    </Button>
                  </Col>

                  <Col
                    sm={5}
                    onClick={() => {
                      setCallFilter("completed");
                      callFilterRef.current = "completed";
                      getCallLogs("task.complete");
                    }}
                  >
                    <Button
                      className={`beam-btn w-70 ${
                        callFilter === "completed" ? "green-btn cover" : ""
                      }`}
                    >
                      Completed
                    </Button>
                  </Col>

                  <Col
                    sm={5}
                    onClick={() => {
                      setCallFilter("missed");
                      callFilterRef.current = "missed";
                      getCallLogs("task.no-answer");
                    }}
                  >
                    <Button
                      className={`beam-btn w-70 ${
                        callFilter === "missed" ? "green-btn cover" : ""
                      }`}
                    >
                      Missed
                      {missed && (
                        <div className="status-badge red position-absolute"></div>
                      )}
                    </Button>
                  </Col>
                </Row>

                <Row className="custom-table mt-4 w-100">
                  <Col span={24}>
                    <Row className="header">
                      <Col span={4}>Time</Col>
                      <Col span={3}>Call type</Col>
                      <Col span={4}>Caller phone</Col>
                      <Col span={3}>Call duration</Col>

                      <Col span={3}>Status</Col>
                      <Col span={3}>Call taker</Col>
                      <Col span={4}>Action</Col>
                    </Row>

                    {callLogs?.map((item, i) => (
                      <Row
                        className="table-row"
                        style={{ alignItems: "baseline" }}
                      >
                        <Col span={4}>
                          {new Date(
                            item.output.activeCallTimestamp
                          ).toLocaleString()}
                        </Col>
                        <Col span={3}>{item.output.callType ?? "N/A"}</Col>
                        <Col span={4}>
                          {item.output.activeCallerPhoneNumber}
                        </Col>
                        <Col span={3}>
                          {item?.output?.callDuration ?? "N/A"}
                        </Col>

                        <Col span={3}>{item.status}</Col>

                        <Col span={3}>
                          {item.output.activeDispatcherId
                            ? getUserName(item.output.activeDispatcherId)
                            : "N/A"}
                        </Col>

                        <Col span={3}>
                          {callFilter === "missed" && (
                            <React.Fragment>
                              <Button
                                className="beam-btn cover mr-2"
                                style={{
                                  minWidth: 50,
                                  minHeight: 50,
                                }}
                                onClick={() => {
                                  completeCall(item.objectId.toString());
                                }}
                              >
                                <CheckOutlined color="#40CC52" />
                              </Button>
                              {/* )} */}

                              <Button
                                className="beam-btn green1-btn cover m-auto"
                                style={{ minWidth: 50, minHeight: 50 }}
                                onClick={() => {
                                  callOutgoing(item);
                                }}
                              >
                                <PhoneOutlined />
                              </Button>
                            </React.Fragment>
                          )}

                          {callFilter === "completed" && item.output.pageId && (
                            <Button
                              className="beam-btn cover mr-2"
                              style={{
                                minWidth: 50,
                                minHeight: 50,
                              }}
                              onClick={() => {
                                window.open(
                                  `${process.env.REACT_APP_WEB}/page/${item.output.pageId}`,
                                  "_blank"
                                );
                              }}
                            >
                              <EyeOutlined color="#40CC52" />
                            </Button>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </Row>
            </Card>
          </Col>

          {reservation && (
            <Col className="gutter-row card-max-height" sm={24} md={8}>
              <Card className="filter-card">
                <Row>
                  <Col sm={24} className="d-flex flex-row justify-content-end">
                    <Button
                      className="beam-btn cover"
                      style={{
                        minWidth: 40,
                        minHeight: 40,
                      }}
                      onClick={() => {
                        socket.publishToEvent(
                          SocketTopics.PublishPageTopics,
                          callAcceptedPublishTopic(currentUserObj?.id),
                          wrapRequestPayload({
                            reservation,
                            workerSid:
                              currentUserObj?.admin?.profile?.workerSid,
                          })
                        );
                      }}
                    >
                      <ExportOutlined color="#40CC52" />
                    </Button>
                  </Col>

                  <Col
                    sm={24}
                    className="mt-3 d-flex flex-column justify-content-space-between"
                    style={{ height: "67vh" }}
                  >
                    {!addParticipant && (
                      <React.Fragment>
                        <div className="text-center">
                          <h2>{reservation?.outgoing ? "Outgoing call": "Incoming Call"}</h2>

                          <h4>{reservation?.phoneNumber ?? ""}</h4>
                          {callOngoing && (
                            <h4>
                              <Timer />
                            </h4>
                          )}
                        </div>

                        <img
                          src="https://cdn3.iconfinder.com/data/icons/avatar-set-2/512/Avata_09-512.png"
                          height={200}
                          width={200}
                          alt=""
                        />

                        {!callOngoing ? (
                          <Row
                            className="d-center mt-3 w-100"
                            style={{ width: "100%" }}
                          >
                            <Col span={8} className="d-flex">
                              <Button
                                className="beam-btn green1-btn cover m-auto"
                                style={{ minWidth: 50, minHeight: 50 }}
                                loading={callConnecting}
                                onClick={() => {
                                  acceptCall();
                                }}
                              >
                                <PhoneOutlined />
                              </Button>
                            </Col>

                            <Col span={8} className="d-flex"></Col>
                            <Col span={8} className="d-flex">
                              <Button
                                className="beam-btn orange-btn cover m-auto"
                                style={{ minWidth: 50, minHeight: 50 }}
                                onClick={() => {
                                  rejectCall();
                                }}
                              >
                                <PhoneOutlined />
                              </Button>
                            </Col>
                          </Row>
                        ) : (
                          <React.Fragment>
                            <Row
                              className="d-center mt-3 w-100"
                              style={{ width: "100%" }}
                            >
                              <Col span={6} className="d-flex">
                                <Button
                                  className="beam-btn m-auto"
                                  style={{ minWidth: 50, minHeight: 50 }}
                                  onClick={() => {
                                    setAddParticipant(true);
                                  }}
                                >
                                  <UserAddOutlined />
                                </Button>
                              </Col>
                              <Col span={6} className="d-flex">
                                <Button
                                  className="beam-btn orange-btn cover m-auto"
                                  style={{ minWidth: 50, minHeight: 50 }}
                                  onClick={() => {
                                    hangUpCall();
                                  }}
                                >
                                  <PhoneOutlined />
                                </Button>
                              </Col>

                              <Col span={6} className="d-flex">
                                <Button
                                  className="beam-btn m-auto"
                                  style={{ minWidth: 50, minHeight: 50 }}
                                  onClick={() => {
                                    holdCall(!hold);
                                  }}
                                >
                                  {!hold ? (
                                    <PauseCircleOutlined />
                                  ) : (
                                    <PlayCircleOutlined />
                                  )}
                                </Button>
                              </Col>

                              <Col span={6} className="d-flex">
                                <Button
                                  className="beam-btn m-auto"
                                  style={{ minWidth: 50, minHeight: 50 }}
                                  onClick={() => {
                                    setMute(!mute);
                                    // console.log(
                                    //   "current conenction",
                                    //   connection.current
                                    // );
                                    connection.current?.mute(!mute);
                                  }}
                                >
                                  {mute ? (
                                    <AudioMutedOutlined />
                                  ) : (
                                    <AudioOutlined />
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}

                    {addParticipant && (
                      <React.Fragment>
                        <Row className="d-flex mt-1 mb-4">
                          <Col>
                            <h2>Add participant</h2>
                          </Col>
                        </Row>
                        <Row className="d-flex mt-4 w-100">
                          <Col span={24}>
                            <Input
                              className="beam-input"
                              value={phoneNumber}
                              onChange={(e) => {
                                // console.log("e", e.target.value);
                                if (
                                  e.target.value.match(/^[0-9+]+$/) !== null ||
                                  e.target.value === ""
                                ) {
                                  setPhoneNumber(e.target.value);
                                }
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="d-flex mt-4 w-100">
                          {_.times(9, (idx) => (
                            <Col span={8} className="d-flex mb-3">
                              <Button
                                className="beam-btn round-btn m-auto mb-4"
                                style={{ minWidth: 50, minHeight: 50 }}
                                key={idx}
                                onClick={() => handleChange(idx + 1)}
                              >
                                {idx + 1}
                              </Button>
                            </Col>
                          ))}
                        </Row>
                        <Row className="d-flex w-100">
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              onClick={() => handleChange("+")}
                              style={{ minWidth: 50, minHeight: 50 }}
                            >
                              +
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange("0")}
                            >
                              0
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange("#")}
                            >
                              #
                            </Button>
                          </Col>
                        </Row>
                        <Row className="d-center mt-3 w-100">
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => {
                                setAddParticipant(false);
                                setPhoneNumber("");
                              }}
                            >
                              <CloseOutlined />
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn round-btn cover green-btn call-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => {
                                handleAddParticipant();
                              }}
                            >
                              <ReactSVG src="/images/call-icon.svg" />
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange(null)}
                            >
                              <ArrowLeftOutlined />
                            </Button>
                          </Col>
                        </Row>
                      </React.Fragment>
                    )}
                  </Col>
                </Row>
              </Card>
            </Col>
          )}
        </Row>
      </Layout>

      {isSaveRecordingVisible && (
        <SaveRecordingModal
          socket={socket}
          onClose={() => {
            setIsSaveRecordingVisible(false);
          }}
          workerSid={currentUserObj?.admin?.profile?.workerSid}
        />
      )}
      {isWelcomeModalVisible && (
        <WelcomeModal
          message={"Are you sure you want to continue?"}
          onClose={() => {
            setIsWelcomeModalVisible(false);
          }}
        />
      )}

      {outgoingModalVisible && (
        <OutgoingModal
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          handleChange={handleChange}
          onClose={() => {
            setOutgoingModalVisible(false);
          }}
          callOutgoing={callOutgoing}
        />
      )}
    </Modal>
  );
};

export default CallCenterModal;
